import { render, staticRenderFns } from "./Revenus.vue?vue&type=template&id=02d1b89d&scoped=true"
import script from "./Revenus.vue?vue&type=script&lang=js"
export * from "./Revenus.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/DemandeBourse.css?vue&type=style&index=0&id=02d1b89d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d1b89d",
  null
  
)

export default component.exports